import { useRouter } from "next/router";
import { resolveImage } from "../../lib/media";
import Picture from "../Picture";
import SectionHeading from "../SectionHeading";

// type Collection = {
//       _id: string;
//       name: string;
//       createdAt: string;
//       updatedAt: string;
//       sortOrder: number;
//       store: string;
//       isFeatured: boolean;
//       isActive: boolean;
//     }

// interface FeaturedCollectionListProps {
//   featuredCollections: Collection[];
//   isLoading: boolean;
// }

const FeaturedCollectionList = ({ featuredCollections, isLoading }) => {
  const renderSkeletons = Array(4)
    .fill(0)
    .map((_, index) => <SkeletonCard key={index} />);

  const renderCollections = featuredCollections.map((collection) => (
    <FeaturedCollectionCard key={collection._id} collection={collection} />
  ));

  return (
    <div className="mt-[50px] pl-[20px] pr-[27px]">
      <SectionHeading label="Featured Collections" />
      <div className="mt-[30px] grid grid-cols-2 gap-x-[19px] gap-y-[36px]">
        {isLoading ? renderSkeletons : renderCollections}
      </div>
    </div>
  );
};

export default FeaturedCollectionList;

const FeaturedCollectionCard = ({ collection }) => {
  const router = useRouter();
  const resolved = resolveImage(collection.image, collection.imageV2, "collection");

  return (
    <div
      onClick={() => router.push(`/shop?collection=${collection.name}`)}
      className="cursor-pointer"
    >
      {collection.image && resolved.isV2 ? (
        <Picture
          resolved={resolved}
          alt="collection image"
          imgClassName="h-[162px] w-full rounded-lg object-cover md:h-[227px]"
        />
      ) : collection.image ? (
        <img
          src={resolved.src}
          alt="collection image"
          className="h-[162px] w-full rounded-lg object-cover md:h-[227px]"
        />
      ) : (
        <div className="h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]" />
      )}

      <p className="mt-1 text-base font-normal text-fontBackground opacity-80">{collection.name}</p>
    </div>
  );
};

const SkeletonCard = () => {
  return (
    <div className="">
      {/* skeleton for image */}
      <div className="h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]" />

      {/* skeleton for name */}
      <div className="mt-1 h-6 w-24 bg-gray-200" />
    </div>
  );
};
